import { render, staticRenderFns } from "./becomePartner.vue?vue&type=template&id=c1b49b9a&scoped=true"
import script from "./becomePartner.vue?vue&type=script&lang=js"
export * from "./becomePartner.vue?vue&type=script&lang=js"
import style0 from "./becomePartner.vue?vue&type=style&index=0&id=c1b49b9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_7907ed7515d572276d45114f834f04a7/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1b49b9a",
  null
  
)

export default component.exports